// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"HW6_buttonsContainer__Oq+En","editableSpanContainer":"HW6_editableSpanContainer__YvX8k"};